enum PORTAL_ROLES {
  EMPLOYER_USER = 'EmployerUser',
  EMPLOYER_ADMIN = 'EmployerAdmin',
  ATRF = 'ATRF',
  ATA = 'ATA',
  NONE = 'None',
}

enum SCOPES {
  VIEW_DEFAULT_NAVIGATION = 'view-default-navigation',
  VIEW_USER_AGREEMENT = 'view-user-agreement',
  VIEW_USERS = 'view-users',
  VIEW_NOTIFICATIONS = 'view-notifications',
  VIEW_RECONCILIATIONS = 'view-reconciliations',
  VIEW_RETRO_PAYS = 'view-retro-pays',
  CHANGE_BOARD = 'change-board',
  VIEW_BOARD = 'view-board',
  ADD_EMPLOYEE = 'add-employee',
  RESET_BATCH = 'reset-batch',
  COPY_BATCH_FORWARD = 'copy-batch-forward',
  BYPASS_VALIDATION = 'bypass-validation',
  EDIT_EMPLOYEE = 'edit-employee',
  REMOVE_EMPLOYEE_FROM_BATCH = 'remove-employee-from-batch',
  ADD_CONTRIBUTION = 'add-contribution',
  DELETE_CONTRIBUTION = 'delete-contribution',
  EDIT_CONTRIBUTION = 'edit-contribution',
  UPLOAD_BATCH = 'upload-batch',
  VALIDATE_BATCH = 'validate-batch',
  SUBMIT_BATCH = 'submit-batch',
  ADD_TO_ERTN = 'add-to-ertn',
  ADD_ERTN = 'add-ertn',
  EDIT_ERTN = 'edit-ertn',
  SUBMIT_ERTN = 'submit-ertn',
  DELETE_ERTN = 'delete-ertn',
  REMOVE_EMPLOYEE_FROM_ERTN = 'remove-employee-from-ertn',
  ADD_CONTRACT = 'add-contract',
  EDIT_CONTRACT = 'edit-contract',
  DELETE_CONTRACT = 'delete-contract',
  ADD_SCHEDULE = 'add-schedule',
  EDIT_SCHEDULE = 'edit-schedule',
  DELETE_SCHEDULE = 'delete-schedule',
  COPY_SCHEDULE = 'copy-schedule',
  EDIT_EMPLOYER = 'edit-employer',
  CHANGE_RECORD = 'change-record',
  VIEW_LOCAL_RATES = 'view-local-rates',
  VIEW_PROVINCIAL_RATES = 'view-provincial-rates',
  VIEW_MISCELLANEOUS_RATES = 'view-miscellaneous-rates',
  VIEW_ALL_RATES = 'view-all-rates',
}

const PERMISSIONS = {
  [PORTAL_ROLES.EMPLOYER_USER]: [
    SCOPES.VIEW_DEFAULT_NAVIGATION,
    SCOPES.VIEW_USER_AGREEMENT,
    SCOPES.ADD_EMPLOYEE,
    SCOPES.RESET_BATCH,
    SCOPES.COPY_BATCH_FORWARD,
    SCOPES.EDIT_EMPLOYEE,
    SCOPES.ADD_CONTRIBUTION,
    SCOPES.DELETE_CONTRIBUTION,
    SCOPES.EDIT_CONTRIBUTION,
    SCOPES.REMOVE_EMPLOYEE_FROM_BATCH,
    SCOPES.UPLOAD_BATCH,
    SCOPES.VALIDATE_BATCH,
    SCOPES.SUBMIT_BATCH,
    SCOPES.ADD_TO_ERTN,
    SCOPES.ADD_ERTN,
    SCOPES.EDIT_ERTN,
    SCOPES.DELETE_ERTN,
    SCOPES.SUBMIT_ERTN,
    SCOPES.REMOVE_EMPLOYEE_FROM_ERTN,
    SCOPES.ADD_CONTRACT,
    SCOPES.EDIT_CONTRACT,
    SCOPES.DELETE_CONTRACT,
    SCOPES.ADD_SCHEDULE,
    SCOPES.EDIT_SCHEDULE,
    SCOPES.DELETE_SCHEDULE,
    SCOPES.COPY_SCHEDULE,
    SCOPES.EDIT_EMPLOYER,
    SCOPES.CHANGE_RECORD,
    SCOPES.VIEW_BOARD,
    SCOPES.VIEW_LOCAL_RATES,
    SCOPES.VIEW_PROVINCIAL_RATES,
    SCOPES.VIEW_MISCELLANEOUS_RATES,
    SCOPES.VIEW_ALL_RATES,
    SCOPES.VIEW_RETRO_PAYS,
  ],
  [PORTAL_ROLES.EMPLOYER_ADMIN]: [
    SCOPES.VIEW_DEFAULT_NAVIGATION,
    SCOPES.VIEW_USER_AGREEMENT,
    SCOPES.VIEW_USERS,
    SCOPES.ADD_EMPLOYEE,
    SCOPES.RESET_BATCH,
    SCOPES.COPY_BATCH_FORWARD,
    SCOPES.EDIT_EMPLOYEE,
    SCOPES.ADD_CONTRIBUTION,
    SCOPES.DELETE_CONTRIBUTION,
    SCOPES.EDIT_CONTRIBUTION,
    SCOPES.REMOVE_EMPLOYEE_FROM_BATCH,
    SCOPES.UPLOAD_BATCH,
    SCOPES.VALIDATE_BATCH,
    SCOPES.SUBMIT_BATCH,
    SCOPES.ADD_TO_ERTN,
    SCOPES.ADD_ERTN,
    SCOPES.EDIT_ERTN,
    SCOPES.DELETE_ERTN,
    SCOPES.SUBMIT_ERTN,
    SCOPES.REMOVE_EMPLOYEE_FROM_ERTN,
    SCOPES.ADD_CONTRACT,
    SCOPES.EDIT_CONTRACT,
    SCOPES.DELETE_CONTRACT,
    SCOPES.ADD_SCHEDULE,
    SCOPES.EDIT_SCHEDULE,
    SCOPES.DELETE_SCHEDULE,
    SCOPES.COPY_SCHEDULE,
    SCOPES.EDIT_EMPLOYER,
    SCOPES.CHANGE_RECORD,
    SCOPES.VIEW_BOARD,
    SCOPES.VIEW_LOCAL_RATES,
    SCOPES.VIEW_PROVINCIAL_RATES,
    SCOPES.VIEW_MISCELLANEOUS_RATES,
    SCOPES.VIEW_ALL_RATES,
    SCOPES.VIEW_RETRO_PAYS,
  ],
  ATRF_SANDBOX: [
    SCOPES.VIEW_DEFAULT_NAVIGATION,
    SCOPES.VIEW_USERS,
    SCOPES.CHANGE_BOARD,
    SCOPES.ADD_EMPLOYEE,
    SCOPES.RESET_BATCH,
    SCOPES.COPY_BATCH_FORWARD,
    SCOPES.EDIT_EMPLOYEE,
    SCOPES.ADD_CONTRIBUTION,
    SCOPES.DELETE_CONTRIBUTION,
    SCOPES.EDIT_CONTRIBUTION,
    SCOPES.REMOVE_EMPLOYEE_FROM_BATCH,
    SCOPES.UPLOAD_BATCH,
    SCOPES.VALIDATE_BATCH,
    SCOPES.SUBMIT_BATCH,
    SCOPES.ADD_TO_ERTN,
    SCOPES.ADD_ERTN,
    SCOPES.EDIT_ERTN,
    SCOPES.DELETE_ERTN,
    SCOPES.SUBMIT_ERTN,
    SCOPES.REMOVE_EMPLOYEE_FROM_ERTN,
    SCOPES.ADD_CONTRACT,
    SCOPES.EDIT_CONTRACT,
    SCOPES.DELETE_CONTRACT,
    SCOPES.ADD_SCHEDULE,
    SCOPES.EDIT_SCHEDULE,
    SCOPES.DELETE_SCHEDULE,
    SCOPES.COPY_SCHEDULE,
    SCOPES.EDIT_EMPLOYER,
    SCOPES.CHANGE_RECORD,
    SCOPES.VIEW_BOARD,
    SCOPES.VIEW_LOCAL_RATES,
    SCOPES.VIEW_PROVINCIAL_RATES,
    SCOPES.VIEW_MISCELLANEOUS_RATES,
    SCOPES.VIEW_ALL_RATES,
    SCOPES.VIEW_RETRO_PAYS,
    SCOPES.BYPASS_VALIDATION,
  ],
  [PORTAL_ROLES.ATRF]: [
    SCOPES.VIEW_DEFAULT_NAVIGATION,
    SCOPES.VIEW_USERS,
    SCOPES.VIEW_NOTIFICATIONS,
    SCOPES.VIEW_RECONCILIATIONS,
    SCOPES.CHANGE_BOARD,
    SCOPES.BYPASS_VALIDATION,
    SCOPES.VIEW_BOARD,
    SCOPES.VIEW_LOCAL_RATES,
    SCOPES.VIEW_PROVINCIAL_RATES,
    SCOPES.VIEW_MISCELLANEOUS_RATES,
    SCOPES.VIEW_ALL_RATES,
  ],
  [PORTAL_ROLES.ATA]: [SCOPES.VIEW_LOCAL_RATES, SCOPES.VIEW_PROVINCIAL_RATES],
  [PORTAL_ROLES.NONE]: [],
};

export { PORTAL_ROLES, SCOPES, PERMISSIONS };
